import { render, staticRenderFns } from "./OperationsHeader.vue?vue&type=template&id=42067a6c&"
import script from "./OperationsHeader.vue?vue&type=script&lang=ts&"
export * from "./OperationsHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports